import { Module, MutationTree, GetterTree, ActionTree } from 'vuex';
import { ReducerStatus, RootState } from '../types';
import { ContentState } from './types';
import { getUpdatedDisclaimers } from '@/helpers/termsAndPoliciesLinks';

const initialState: ContentState = {
    checkout: {
        status: ReducerStatus.INITIAL,
        data: null,
    },
    payment: {
        status: ReducerStatus.INITIAL,
        data: null,
    },
    booking: {
        status: ReducerStatus.INITIAL,
        data: null,
    },
};

const state: ContentState = {
    ...initialState,
};

const getters: GetterTree<ContentState, RootState> = {
    getCheckoutContent(state) {
        return state.checkout.data;
    },
    getCheckoutNationalities(state) {
        return state.checkout.data?.Nationalities ?? [];
    },
    getCheckoutCurrentNationality(state) {
        return state.checkout.data?.CurrentNationality ?? null;
    },
    getCheckoutGenderTitles(state) {
        return state.checkout.data?.GenderTitles ?? null;
    },
    getCheckoutAgeRangeDefinitions(state) {
        return (
            (state.checkout.data?.AgeRangeDefinitions ||
                state.payment.data?.AgeRangeDefinitions) ??
            null
        );
    },
    getCheckoutSpecialNeedsOptions(state) {
        return (
            (state.checkout.data?.SpecialNeedsOptions ||
                state.booking.data?.SpecialNeedsOptions) ??
            null
        );
    },
    getCheckoutDisclaimers(state) {
        const disclaimers = state.checkout.data?.Disclaimers;

        return disclaimers ? getUpdatedDisclaimers(disclaimers) : null;
    },
    getCheckoutPhoneNumberPrefixes(state) {
        return state.checkout.data?.PhoneNumberPrefixes ?? null;
    },
    getPaymentContent(state) {
        return state.payment.data;
    },
    getBookingContent(state) {
        return state.booking.data;
    },
};

const actions: ActionTree<ContentState, RootState> = {
    setCheckoutLoading({ state, commit }) {
        commit('setCheckoutState', {
            ...state.checkout,
            status: ReducerStatus.LOADING,
        });
    },

    setCheckoutSuccess({ commit }, payload) {
        commit('setCheckoutState', {
            status: ReducerStatus.LOADED,
            data: payload,
        });
    },

    setCheckoutError({ commit }) {
        commit('setCheckoutState', {
            status: ReducerStatus.ERROR,
            data: null,
        });
    },

    setPaymentLoading({ state, commit }) {
        commit('setPaymentState', {
            ...state.checkout,
            status: ReducerStatus.LOADING,
        });
    },

    setPaymentSuccess({ commit }, payload) {
        commit('setPaymentState', {
            status: ReducerStatus.LOADED,
            data: payload,
        });
    },

    setPaymentError({ commit }) {
        commit('setPaymentState', {
            status: ReducerStatus.ERROR,
            data: null,
        });
    },

    setBookingLoading({ state, commit }) {
        commit('setBookingState', {
            ...state.booking,
            status: ReducerStatus.LOADING,
        });
    },

    setBookingSuccess({ commit }, payload) {
        commit('setBookingState', {
            status: ReducerStatus.LOADED,
            data: payload,
        });
    },

    setBookingError({ commit }) {
        commit('setBookingState', {
            status: ReducerStatus.ERROR,
            data: null,
        });
    },
};

const mutations: MutationTree<ContentState> = {
    setCheckoutState(state, payload) {
        state.checkout.status = payload.status;
        state.checkout.data = payload.data;
    },
    setPaymentState(state, payload) {
        state.payment.status = payload.status;
        state.payment.data = payload.data;
    },
    setBookingState(state, payload) {
        state.booking.status = payload.status;
        state.booking.data = payload.data;
    },
};

export const content: Module<ContentState, RootState> = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
